import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FiMenu,
  FiX,
  FiHome,
  FiGrid,
  FiLayout,
  FiTag,
  FiBook,
  FiShoppingBag
} from "react-icons/fi";

const HeaderMobile = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <header className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 w-[95%] sm:w-auto">
      <div className="relative">
        <motion.nav
          animate={open ? "open" : "closed"}
          initial="closed"
          className="bg-cream text-cocoa shadow-lg flex items-center justify-center rounded-full relative px-4 py-2"
        >
          <MenuButton setOpen={setOpen} open={open} className="absolute left-2" />
          
          <div className="flex items-center justify-center gap-4 sm:gap-6 mx-auto">
            {LINKS.slice(0, 4).map((link, index) => (
              <NavLink key={index} {...link} onClick={handleClose} />
            ))}
          </div>
        </motion.nav>

        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.2 }}
              className="absolute bottom-full left-0 right-0 mb-2 w-full"
            >
              <Menu onItemClick={handleClose} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

const NavLink = ({ text, Icon, href, onClick }) => {
  return (
    <Link
      to={href}
      onClick={onClick}
      className="flex flex-col items-center justify-center p-2 sm:p-3 
                 hover:text-brandy-rose transition-colors rounded-full
                 hover:bg-cream/10 min-w-[48px] sm:min-w-[60px]"
    >
      <Icon className="text-lg sm:text-xl mb-1" />
      <span className="text-[10px] sm:text-xs text-center">{text}</span>
    </Link>
  );
};

const MenuButton = ({ open, setOpen }) => {
  return (
    <div
      onClick={() => setOpen((prev) => !prev)}
      className="p-3 sm:p-4 hover:bg-cocoa/10 rounded-full transition-colors"
    >
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="text-xl sm:text-2xl"
      >
        <AnimatePresence mode="wait">
          {open ? (
            <motion.span
              key="close"
              initial={{ opacity: 0, rotate: -180 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: 180 }}
              transition={{ duration: 0.2 }}
            >
              <FiX />
            </motion.span>
          ) : (
            <motion.span
              key="menu"
              initial={{ opacity: 0, rotate: 180 }}
              animate={{ opacity: 1, rotate: 0 }}
              exit={{ opacity: 0, rotate: -180 }}
              transition={{ duration: 0.2 }}
            >
              <FiMenu />
            </motion.span>
          )}
        </AnimatePresence>
      </motion.button>
    </div>
  );
};

const Menu = ({ onItemClick }) => {
  return (
    <div className="bg-cream text-cocoa p-4 rounded-2xl shadow-xl">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {LINKS.map((link, index) => (
          <Link
            key={index}
            to={link.href}
            onClick={onItemClick}
            className="flex items-center gap-2 p-3 hover:bg-cocoa/10 
                       rounded-xl transition-colors"
          >
            <link.Icon className="text-lg sm:text-xl" />
            <span className="text-sm sm:text-base">{link.text}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

const LINKS = [
  {
    text: "Accueil",
    Icon: FiHome,
    href: "/"
  },
  {
    text: "Catégories",
    Icon: FiGrid,
    href: "/categories"
  },
  {
    text: "Projets",
    Icon: FiLayout,
    href: "/projects"
  },
  {
    text: "Marques",
    Icon: FiTag,
    href: "/our-brands"
  },
  {
    text: "Histoire",
    Icon: FiBook,
    href: "/our-history"
  },
  {
    text: "e-Shop",
    Icon: FiShoppingBag,
    href: "https://x0m31k-rp.myshopify.com/"
  }
];

export default HeaderMobile;